import PinUploader from "./views";
import ModalWrapper from "./views/ModalWrapper";

export const PinUploaderModal = ModalWrapper;
export default PinUploader;
